import { CourseShowPageState } from '../../../../containers/courses/states/CourseShowPageState';
import { SectionId } from '../../../../../commonv3/types/sections';
import { action, computed, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { SectionShowView } from '../../../../types/sections';
import { SectionApis } from '../../../../apis/sections';
import { LessonId } from '../../../../types/lessons';
import { SectionEventType } from '../../../../../commonv3/types/section_events';
import { EventCategory, SheEventClient } from '../../../../../commonv3/events/SheEventClient';

export class SectionDetailsPaneState {
    courseState: CourseShowPageState;
    @observable lessonId: LessonId = null;
    @observable sectionId: SectionId = null;
    @observable sectionDetail: RemoteResourceV3<SectionShowView> = RemoteResourceV3.loading();

    constructor(courseState: CourseShowPageState) {
        this.courseState = courseState;
    }

    @action.bound
    async init(lessonId: LessonId, sectionId: SectionId) {
        this.lessonId = lessonId;
        this.sectionId = sectionId;
        await this.reloadSection();
        if (!this.sectionDetail.isEmpty()) {
            SheEventClient.reportEvent(EventCategory.COURSE, 'section_opened', {
                course_id: this.courseState.courseId,
                course_title: this.courseState.courseTitle,
                lesson_id: lessonId,
                lesson_title: this.lessonTitle,
                section_id: sectionId,
                section_title: this.sectionTitle,
            });
            this.courseState.reportSectionEvent(lessonId, sectionId, SectionEventType.SECTION_OPENED);
        }
    }

    @computed
    get lesson() {
        return this.courseState.getLesson(this.lessonId);
    }

    @computed
    get lessonTitle() {
        if (!this.lesson) {
            return '';
        }
        return this.lesson.title;
    }

    @computed
    get section() {
        return this.courseState.getSection(this.lessonId, this.sectionId);
    }

    @computed
    get sectionTitle() {
        if (!this.section) {
            return '';
        }
        return this.section.title;
    }

    @action.bound
    async reloadSection() {
        await updateRemoteResourceV3(
            this.sectionDetail,
            (v) => (this.sectionDetail = v),
            () => SectionApis.show(this.sectionId)
        );
    }
}
